import { EventTypes } from 'modules/domains/segmentation';

export const HUMAN_READABLE_ITERABLE_EVENTS: Record<EventTypes, string> = {
  [EventTypes.Bounce]: 'Email Bounce',
  [EventTypes.Click]: 'Email Click',
  [EventTypes.Complaint]: 'Email Complaint',
  [EventTypes.CustomEvent]: 'Custom Event',
  [EventTypes.HostedUnsubscribeClick]: 'Hosted Unsubscribe Click',
  [EventTypes.Send]: 'Email Send',
  [EventTypes.SendSkip]: 'Email Send Skip',
  [EventTypes.Subscribe]: 'Subscribe',
  [EventTypes.UnSubscribe]: 'Unsubscribe',
  [EventTypes.User]: 'User',
  [EventTypes.Open]: 'Email Open',
  [EventTypes.PushSend]: 'Push Send',
  [EventTypes.PushBounce]: 'Push Bounce',
  [EventTypes.PushOpen]: 'Push Open',
  [EventTypes.PushSendSkip]: 'Push Send Skip',
  [EventTypes.InAppClick]: 'In-App Click',
  [EventTypes.InAppClose]: 'In-App Close',
  [EventTypes.InAppDelivery]: 'In-App Delivery',
  [EventTypes.InAppDelete]: 'In-App Delete',
  [EventTypes.InAppOpen]: 'In-App Open',
  [EventTypes.InAppRecall]: 'In-App Recall',
  [EventTypes.InAppSend]: 'In-App Send',
  [EventTypes.InAppSendSkip]: 'In-App Send Skip',
  [EventTypes.InboxMessageImpression]: 'Inbox Message Impression',
  [EventTypes.InboxSession]: 'Inbox Session',
  [EventTypes.PushUninstall]: 'Push Uninstall',
  [EventTypes.Purchase]: 'Purchase',
  [EventTypes.SMSBounce]: 'SMS Bounce',
  [EventTypes.SMSClick]: 'SMS Click',
  [EventTypes.SMSReceived]: 'SMS Received',
  [EventTypes.SMSSend]: 'SMS Send',
  [EventTypes.SMSSendSkip]: 'SMS Send Skip',
  [EventTypes.SMSUsageInfo]: 'SMS Usage Info',
  [EventTypes.WebPushClick]: 'Web Push Click',
  [EventTypes.WebPushSend]: 'Web Push Send',
  [EventTypes.WebPushSendSkip]: 'Web Push Send Skip',
};

export const ITERABLE_EVENTS: Record<EventTypes, string> = {
  [EventTypes.Bounce]: 'emailBounce',
  [EventTypes.Click]: 'emailClick',
  [EventTypes.Complaint]: 'emailComplaint',
  [EventTypes.CustomEvent]: 'customEvent',
  [EventTypes.HostedUnsubscribeClick]: 'hostedUnsubscribeClick',
  [EventTypes.Send]: 'emailSend',
  [EventTypes.SendSkip]: 'emailSendSkip',
  [EventTypes.Subscribe]: 'emailSubscribe',
  [EventTypes.UnSubscribe]: 'emailUnSubscribe',
  [EventTypes.User]: 'user',
  [EventTypes.Open]: 'emailOpen',
  [EventTypes.PushSend]: 'pushSend',
  [EventTypes.PushBounce]: 'pushBounce',
  [EventTypes.PushOpen]: 'pushOpen',
  [EventTypes.PushSendSkip]: 'pushSendSkip',
  [EventTypes.InAppClick]: 'inAppClick',
  [EventTypes.InAppClose]: 'inAppClose',
  [EventTypes.InAppDelivery]: 'inAppDelivery',
  [EventTypes.InAppDelete]: 'inAppDelete',
  [EventTypes.InAppOpen]: 'inAppOpen',
  [EventTypes.InAppRecall]: 'inAppRecall',
  [EventTypes.InAppSend]: 'inAppSend',
  [EventTypes.InAppSendSkip]: 'inAppSendSkip',
  [EventTypes.InboxMessageImpression]: 'inboxMessageImpression',
  [EventTypes.InboxSession]: 'inboxSession',
  [EventTypes.PushUninstall]: 'pushUninstall',
  [EventTypes.Purchase]: 'purchase',
  [EventTypes.SMSBounce]: 'smsBounce',
  [EventTypes.SMSClick]: 'smsClick',
  [EventTypes.SMSReceived]: 'smsReceived',
  [EventTypes.SMSSend]: 'smsSend',
  [EventTypes.SMSSendSkip]: 'smsSendSkip',
  [EventTypes.SMSUsageInfo]: 'smsUsageInfo',
  [EventTypes.WebPushClick]: 'webPushClick',
  [EventTypes.WebPushSend]: 'webPushSend',
  [EventTypes.WebPushSendSkip]: 'webPushSendSkip',
};
